import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://edbeqyfwmfhsmvvceoci.supabase.co';
const supabaseAnonKey = 'sb_publishable_7metZdQ8HPZAg1E8ew7qTw_6Dq8xirE';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
